import React from 'react';

const TeamsContext = React.createContext({
    teams: [],
    setTeams: () => { }
})

export default TeamsContext;